import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const EditShg = () => {
  const { id } = useParams();
  console.log("shg Id", id);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;

  const initialStage = {
    name: "",
    code: "",
    vfcId: "",
    type: "",
    location: "",
    address: "",
    village: "",
    panchayath: "",
    thaluk: "",
    pinCode: "",
    dateOfEstablishment: "",
    bankName: "",
    branch: "",
    accountNumber: "",
    ifscCode: "",
  };

  const [errors, setErrors] = useState({});
  const [vfcOptions, setVfcOptions] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [submitMessage, setSubmitMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const validateForm = (formData) => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "code",
      "vfcId",
      "type",
      "location",
      "address",
      "village",
      "panchayath",
      "thaluk",
      "pinCode",
      "dateOfEstablishment",
      "bankName",
      "branch",
      "accountNumber",
      "ifscCode",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) newErrors[field] = `${field} is required`;
    });

    return newErrors;
  };

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcOptions(data);
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };

    const fetchSHGData = async () => {
      try {
        const response = await axios.get(`${Api}/api/shgs/${id}`);
        setFormData(response.data.shg || initialStage); // Adjusted to match the response structure
        setLoading(false);
      } catch (error) {
        console.error("Error fetching SHG data", error);
        toast.error("Failed to fetch SHG data.");
        setLoading(false);
      }
    };

    fetchVfc();
    fetchSHGData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await axios.put(`${Api}/api/shgs/${id}`, formData);
        setSubmitMessage(response.data.shgs);
        toast.success("SHG updated successfully");
        navigate("/dashboard/SHG/manage");
        setFormData(initialStage);
      } catch (error) {
        console.error("Error updating SHG", error);
        toast.error("Failed to update SHG");
      }
    } else {
      toast.error("Please fix the form errors before submitting");
    }
  };

  return (
    <Container>
      <h1>Edit SHG</h1>
      <Preloader loading={loading} />
      <>
        {submitMessage && <Alert variant="success">{submitMessage}</Alert>}

        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <p className="card-description">SHG Registration Form</p>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="name">
                      <Form.Label>Name</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          name="name"
                          value={formData?.name || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.name}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="code">
                      <Form.Label>Code</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Code"
                          name="code"
                          value={formData?.code || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.code}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.code}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="vfcId">
                      <Form.Label>VFC ID</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          as="select"
                          name="vfcId"
                          value={formData?.vfcId || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.vfcId}
                        >
                          <option value="">Select VFC</option>
                          {vfcOptions.map((vfc) => (
                            <option key={vfc._id} value={vfc._id}>
                              {vfc.vfcName}
                            </option>
                          ))}
                        </Form.Control>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.vfcId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="type">
                      <Form.Label>Type</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Type"
                          name="type"
                          value={formData?.type || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.type}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.type}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="location">
                      <Form.Label>Location</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Location"
                          name="location"
                          value={formData?.location || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.location}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.location}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="address">
                      <Form.Label>Address</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          name="address"
                          value={formData?.address || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.address}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="village">
                      <Form.Label>Village</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Village"
                          name="village"
                          value={formData?.village || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.village}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.village}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="panchayath">
                      <Form.Label>Panchayath</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Panchayath"
                          name="panchayath"
                          value={formData?.panchayath || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.panchayath}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.panchayath}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="thaluk">
                      <Form.Label>Thaluk</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Thaluk"
                          name="thaluk"
                          value={formData?.thaluk || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.thaluk}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.thaluk}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="pinCode">
                      <Form.Label>Pin Code</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Pin Code"
                          name="pinCode"
                          value={formData?.pinCode || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.pinCode}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.pinCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="dateOfEstablishment">
                      <Form.Label>Date of Establishment</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="date"
                          name="dateOfEstablishment"
                          value={
                            formData?.dateOfEstablishment
                              ? new Date(formData.dateOfEstablishment)
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          onChange={handleChange}
                          isInvalid={!!errors.dateOfEstablishment}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.dateOfEstablishment}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="bankName">
                      <Form.Label>Bank Name</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Bank Name"
                          name="bankName"
                          value={formData?.bankName || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.bankName}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.bankName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="branch">
                      <Form.Label>Branch</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Branch"
                          name="branch"
                          value={formData?.branch || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.branch}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.branch}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="accountNumber">
                      <Form.Label>Account Number</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter Account Number"
                          name="accountNumber"
                          value={formData?.accountNumber || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.accountNumber}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.accountNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="ifscCode">
                      <Form.Label>IFSC Code</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="text"
                          placeholder="Enter IFSC Code"
                          name="ifscCode"
                          value={formData?.ifscCode || ""}
                          onChange={handleChange}
                          isInvalid={!!errors.ifscCode}
                        />
                      </div>
                      <Form.Control.Feedback type="invalid">
                        {errors.ifscCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <button
                  type="submit"
                  className="btn btn-outline-primary btn-icon-text mt-3"
                >
                  <i className="mdi mdi-file-check btn-icon-prepend"></i>
                  Submit
                </button>
                <button className="btn btn-light mt-3">Cancel</button>
              </Form>
            </div>
          </div>
        </div>
      </>
    </Container>
  );
};

export default EditShg;
